export default "__VITE_ASSET__C4BhgTJ2__"